import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../weeklyTradeDataSlice";
import getWeeklyClientData from "../api/getWeeklyClientData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.weeklyTrade;

  const pagedTrades = await dispatch(getWeeklyClientData(user, filter));

  dispatch(setData(pagedTrades || []));
};
